
import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { GreyWrapperComponent } from 'src/app/components/wrappers/grey-wrapper.component';
import { Entity, EntityName } from 'globals/store/entity.data';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'manage-contact-details',
    template: `
<h3 class="heading contact-title">{{ entityName }} contact details</h3>
<div class="contact-note" *ngIf="!hideNote">Note: these details will not be published in the event program.</div>
<div class="toggle-section" *ngIf="!!nameProp && !!numberProp && !!emailProp && entity">
  <grey-wrapper class="half-column">
    <div class="entry-title">{{ entityName }} contact name</div>
    <joi-input [italicPlaceholder]="true" [fixedWidth]="true" [disabled]="readOnly" [(model)]="entity[nameProp]" [placeholder]="readOnly ? entityName + ' contact name' : 'Click to add ' + lowerEntityName + ' contact name...'" (joiChange)="contactDetailsChanged.emit()"></joi-input>
  </grey-wrapper>
</div>
<div class="toggle-section" *ngIf="!!numberProp && !!emailProp && entity">
  <grey-wrapper class="half-column">
    <div class="entry-title">{{ entityName }} contact phone</div>
    <joi-input [italicPlaceholder]="true" [fixedWidth]="true" [disabled]="readOnly" [(model)]="entity[numberProp]" [placeholder]="readOnly ? entityName + ' contact phone' : 'Click to add ' + lowerEntityName + ' contact phone...'" (joiChange)="contactDetailsChanged.emit()"></joi-input>
  </grey-wrapper>
  <grey-wrapper class="half-column">
    <div class="entry-title">{{ entityName }}  contact email</div>
    <joi-input 
      [italicPlaceholder]="true" [fixedWidth]="true" [disabled]="readOnly" [(model)]="entity[emailProp]" [placeholder]="readOnly ? entityName + ' contact email' : 'Click to add ' + lowerEntityName + ' contact email...'" (joiChange)="contactDetailsChanged.emit()"></joi-input>
  </grey-wrapper>
</div>
<div class="toggle-section" *ngIf="!!entity && !!entity.contactFullAddress">
  <grey-wrapper class="full-column">
    <div class="entry-title">{{ entityName }}  contact address</div>
    <input-editor 
      [object]="entity" 
      [prop]="'contactFullAddress'" 
      [disabled]="readOnly"
      [placeholder]="readOnly ? entityName + ' contact address' : 'Click to add ' + lowerEntityName + ' contact address...'"
      (changed)="contactDetailsChanged.emit()"
    ></input-editor>
  </grey-wrapper>
</div>
`,
    styles: [`
  .contact-note { margin-top: 10px; }
  .entry-title { font-weight: normal; line-height: 11px; color: rgba(0,0,0,.4); font-size: 12px; }
  ::ng-deep grey-wrapper .grey-wrapper { padding: 10px !important; }
  .full-column { width: 100%; margin-right: 20px; max-width: 820px; }
`],
    standalone: true,
    imports: [InputEditorComponent, GreyWrapperComponent, JoiInputComponent, CommonModule ],
})
export class ManageContactDetailsComponent<T extends Entity, P extends keyof T> implements OnInit {
  @Input() entity: T & { contactFullAddress?: string }
  @Input() entityName: EntityName
  @Input() readOnly: boolean = true
  @Input() nameProp: P
  @Input() numberProp: P
  @Input() emailProp: P
  @Input() hideNote: boolean

  lowerEntityName = ''

  @Output() contactDetailsChanged: EventEmitter<void> = new EventEmitter()

  ngOnInit() {
    this.lowerEntityName = this.entityName.toLowerCase()
  }

}



